import { packages } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const useArchivedPacks = () => {
	return useQuery({
		queryKey: ['archived-packs'],
		queryFn: () => packages.getArchivedPacks(),
		select: data => data.data
	})
}